import get from 'Utils/lodash.get';
import CONSTS from 'Config/constans';

// ToDo
// If you need this function - probably something wrong
export function getFieldOptionsByOneOf(oneOf) {
  if (Array.isArray(oneOf)) {
    return oneOf;
  }
  if (typeof oneOf === 'string') {
    return get(CONSTS, oneOf, []);
  }
  return [];
}

/**
 * Expected array with two number,
 * return array numbers between range including range edges
 * @param range {array} - two number element
 * @param range[0] {number} - from
 * @param range[1] {number} - to
 */
export function getFieldOptionsByRange(range) {
  if (!(Array.isArray(range) && range.length === 2)) return [];
  const options = [];
  for (let i = range[0]; i <= range[1]; i++) {
    options.push(i);
  }
  return options;
}

export function getFieldOptionsByParams(params) {
  if (params.type === 'boolean' || params.type === 'bool') return undefined;
  if (['booleanradio'].includes(params.type)) return getFieldOptionsByOneOf('BOOLEAN_RADIO');
  const options = get(params, 'validate.oneOf') || get(params, 'validate.manyOf');
  if (options) {
    return getFieldOptionsByOneOf(options);
  }
  const range = get(params, 'validate.range');
  if (range) {
    return getFieldOptionsByRange(range);
  }
  return [];
}

export function appendParamsToFormData(params, formData = new FormData()) {
  if (params) {
    Object.keys(params).forEach(param => formData.append(param, params[param]));
  }
  return formData;
}
